/**
 * Which business shareholders have their individual owners showing.
 *
 * Companies start open — whether their owners are declared is the thing this
 * view leads with — so this tracks who has been collapsed, not who has been
 * expanded, letting every company not yet touched default to open.
 */

import { useState } from "react";

export function useExpandedCompanies() {
  const [collapsed, setCollapsed] = useState(() => new Set());

  const toggleCompany = (uuid) =>
    setCollapsed((previous) => {
      const next = new Set(previous);
      if (next.has(uuid)) next.delete(uuid);
      else next.add(uuid);
      return next;
    });

  return { isExpanded: (uuid) => !collapsed.has(uuid), toggleCompany };
}
